import React from "react";
import { IResourceComponentsProps } from "@pankod/refine-core";
import { IRetireRule } from "interfaces";
import { Button, CreateButton, DateField, DeleteButton, Divider, EditButton, Icons, Input, List, RefreshButton, Space, Table, useTable,Tag, getDefaultSortOrder, useModalForm, Form,  } from "@pankod/refine-antd";
import {CreateRetireRule} from './create'
import {EditRetireRule} from './edit'
import { exportToExcel } from "exportToExcel";

export const RetireRuleList: React.FC<IResourceComponentsProps> = () => {
    const { tableProps, sorter, tableQueryResult,setFilters,searchFormProps } = useTable<IRetireRule>({
        initialSorter: [
          {
            field: 'created_at',
            order: 'desc',
          },
        ],
        metaData: {
          fields: ['id', 'name', 'created_at','condition_attribute','duration_unit','count','date_range','active','duration',
          { rule_condition: ['name'] },
        ],
        },
        onSearch: (values:any) => {
          return [
              {
                  field: "name",
                  operator: "contains",
                  value:`%${values.title}%`,
              },
          ];
      },
      })
      const { tableQueryResult:exportData } = useTable<IRetireRule>({
        hasPagination:false,
        initialSorter: [
          {
            field: 'created_at',
            order: 'desc',
          },
        ],
        metaData: {
          fields: ['id', 'name', 'created_at','condition_attribute','duration_unit','count','date_range','active','duration',
          { rule_condition: ['name'] },
        ],
        },
      })
      const { formProps, modalProps, show } = useModalForm({
        resource: 'retire_rules',
        action: 'create',
      })
      const {
        formProps: editFormProps,
        modalProps: editModalProps,
        show: editShow,
      } = useModalForm({
        resource: 'retire_rules',
        action: 'edit',
        metaData: {
          fields: ['id', 'name', 'created_at','active','duration','duration_unit','count','date_range','condition_attribute'],
        },
      })
      const triggerExport=()=>{
        exportToExcel(exportData?.data?.data,`AutoRules_${Math.round(new Date().getTime() / 1000)}.xlsx`)
      }
    return(
        <List
    
        
        pageHeaderProps={{
            
           
          extra: [
            
            //  <ExportButton onClick={triggerExport} loading={isLoading} />,
            <RefreshButton onClick={() => tableQueryResult?.refetch()} />,
            <CreateButton type="primary" icon={<Icons.PlusOutlined />} onClick={() => show()} />,
            <Button onClick={triggerExport}>Export</Button>
          ],
        }}
      >
       <Form {...searchFormProps}>
        <Space>
            <Form.Item name="title">
                <Input placeholder="Search by title" allowClear  onChange={(e)=>{
                            if(e.type==='click'){
                              searchFormProps.form?.submit()
                            }}}/>
            </Form.Item>
            <Button icon={<Icons.SearchOutlined/>} onClick={searchFormProps.form?.submit} >Search</Button>
        </Space>
    </Form>
    <Divider/>
        <Table {...tableProps} rowKey="id" size="small">
          <Table.Column dataIndex="name" title="Name" render={(_, record:IRetireRule) => (<>{record?.name}<Tag color={record?.active?'green':'red'}>{record?.active? 'Active':'Disabled'}</Tag></>)} />
          <Table.Column dataIndex="rule_condition"   render={(_, record:IRetireRule) => (<>{record?.rule_condition?.name}</>)}  title="Criteria" />
          <Table.Column dataIndex="duration_unit"     title="Unit" />
          <Table.Column dataIndex="duration"     title="Duration" />
          <Table.Column
            dataIndex="created_at"
            title="Created At"
            render={value => <DateField value={value} format="LLL" />}
            defaultSortOrder={getDefaultSortOrder('created_at', sorter)}
            sorter
          />
          <Table.Column<IRetireRule>
            title="Actions"
            dataIndex="actions"
            render={(_, record) => (
              <Space>
                <EditButton size="small" type="link" icon={null} recordItemId={record.id} onClick={() => editShow(record.id)} />
               <DeleteButton
                                  size="small"
                                  type="link"
                                  icon={null}
                                  recordItemId={record.id}
                              />
              </Space>
            )}
          />
        </Table>
        <CreateRetireRule modalProps={modalProps} formProps={formProps} />
        <EditRetireRule modalProps={editModalProps} formProps={editFormProps} />
      </List>
    )
}